module.exports = __webpack_public_path__ + "static/fonts/PlusJakartaDisplay-Bold.6bfe629a.woff2";